module.exports = __webpack_public_path__ + "static/media/_MIC2323.image.004bf998.png";